import { imageFieldsFrag } from '@/service/fragments/imageFieldsFrag'
import { gql } from '@/service/gql'
import { playableEntityFrag } from '@/service/fragments/playableEntityFrag'
import type { ResultOf } from 'gql.tada'

// language=GraphQL
export const albumFieldsFrag = gql(
    `
        fragment albumFields on Album @_unmask {
            ...playableEntity
            id
            title
            contributingArtists {
                concatenatedName
            }
            images {
                ...imageFields
            }
        }
    `,
    [imageFieldsFrag, playableEntityFrag]
)

export type AlbumFields = ResultOf<typeof albumFieldsFrag>
